import { ThemeOptions } from '@mui/material';

export const menuThemeOptions: ThemeOptions = {
  components: {
    MuiMenu: {
      styleOverrides: {
        root: {
          padding: '0px',
          '& .MuiPaper-root': {
            boxShadow: '0px 16px 40px hsla(0, 0%, 0%, 0.08)',
          },
          '& .MuiList-root': { padding: '0px' },
          '& .MuiListItemText-root': { margin: '0px' },
        },
      },
    },
  },
};
